var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgPlusSmall(props, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10 5.00098C10.4142 5.00101 10.75 5.33678 10.75 5.75098V9.25H14.249C14.6632 9.25 14.999 9.58583 14.999 10C14.999 10.4142 14.6632 10.75 14.249 10.75H10.75V14.249C10.75 14.6632 10.4142 14.999 10 14.999C9.58579 14.999 9.25 14.6632 9.25 14.249V10.75H5.75098C5.33676 10.75 5.00098 10.4142 5.00098 10C5.00103 9.58583 5.3368 9.25 5.75098 9.25H9.25V5.75098C9.25 5.33676 9.58579 5.00098 10 5.00098Z",
    fill: "currentColor"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlusSmall);
export default __webpack_public_path__ + "static/media/plus-small.ab406280.svg";
export { ForwardRef as ReactComponent };